import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "@/i18n";

const I18nContext = createContext(null);

const detectLang = () => {
  const saved = localStorage.getItem("agora_lang");
  if (saved) return saved;
  const nav = (navigator.language || "it").slice(0, 2);
  return nav === "en" ? "en" : "it";
};

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectLang());
  const setLang = useCallback((l) => {
    localStorage.setItem("agora_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => translations[lang][key] || translations.it[key] || key, [lang]);
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
